import axios from "axios";

// URLs provided by user
const USER_DETAILS_URL = "/UserDetails/GetUserDetails";
const ROSTER_BASE_URL = "/Roster";

const ShiftExchangeService = {
  
  // Get all user details
  getAllUsers: () => {
    return axios.get(USER_DETAILS_URL);
  },

  // Get roster details (Assuming it might take params or returns all)
  // Payload/Params aren't specified but typically roster is for a range or just all. 
  // Given the user context, it might be a GET without params or we might need to filter client side.
  getRosterDetails: () => {
    return axios.get(`${ROSTER_BASE_URL}/GetRosterdetails`);
  },

  // Get schedule details (Shift definitions)
  getScheduleDetails: () => {
    return axios.get(`${ROSTER_BASE_URL}/GetSheduledetails`); 
  },

  // Update employee roster
  // Payload: [{"service_no": "727", "WorkDate": "2026-02-05", "shift_code": "TT"}]
  postEmployeeRoster: (rosterData) => {
    return axios.post(`${ROSTER_BASE_URL}/PostEmployeeRoster`, rosterData, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
  }
};

export default ShiftExchangeService;
